import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WorldBuilderAbortConfirmModalComponent } from '../../features/world-builder/modal/world-builder-abort-confirm-modal/world-builder-abort-confirm-modal.component';
import { ConfirmModalComponent } from '../../modal/confirm-modal/confirm-modal.component';
import { DeleteGameAndCharacterModalComponent } from '../game-master-detail/delete-character-modal/delete-character-modal.component';
import { ContentDeleteModalComponent } from '../../modal/content-delete-modal/content-delete-modal.component';
import { CityEnterDeletemodelComponent } from '../../modal/deletemodel/deletemodel.component';
import { MapDeleteComponent } from '../maplist/map-delete/map-delete.component';
import { MapDeleteConfirmationComponent } from '../subscription/subscription-downgrade/modals/map-delete-confirmation/map-delete-confirmation.component';
import { GameDeleteConfirmationComponent } from '../subscription/subscription-downgrade/modals/game-delete-confirmation/game-delete-confirmation.component';
import { CharacterDeleteConfirmationComponent } from '../subscription/subscription-downgrade/modals/character-delete-confirmation/character-delete-confirmation.component';
import { AccountCleanupWizardComponent } from '../subscription/subscription-downgrade/modals/account-cleanup-wizard/account-cleanup-wizard.component';
import { SavingLoaderModalComponent } from '../../modal/saving-loader-modal/saving-loader-modal.component';
import { TokenPlacementModalComponent } from '../../modal/token-placement-modal/token-placement-modal.component';
import { ReportingModalComponent } from '../../modal/reporting-modal/reporting-modal.component';
import { PlayerStoryComponent } from '../../modal/player-story/player-story.component';
import { NoteListComponent } from '../../modal/note-list/note-list.component';
import { CategoryPlayerViewModalComponent } from '../../modal/category-player-view-modal/category-player-view-modal.component';
import { CreateGameInfoModalComponent } from '../active-games/create-game-info-modal/create-game-info-modal.component';
import { UploadpartytokenComponent } from '../active-games/uploadpartytoken/uploadpartytoken.component';
import { CreategameComponent } from '../active-games/creategame/creategame.component';
import { AzgaarMapGeneratorInfoComponent } from '../maplist/azgaar-map-generator-info/azgaar-map-generator-info.component';
import { MapImageChangeComponent } from '../maplist/map-image-change/map-image-change.component';
// Side-effect import only: these components are declared in SubscriptionModule (standalone: false),
// which is normally lazy-loaded by the router before they're ever opened. Theme Lab imports the
// component classes directly, bypassing that — without evaluating SubscriptionModule at least once,
// Ivy never patches pipe/directive defs onto them, and any `| pipe` in their templates crashes with
// "Cannot read properties of undefined (reading 'onDestroy')" the first time they render.
import '../subscription/subscription.module';

@Component({
  selector: 'app-theme-lab',
  templateUrl: './theme-lab.component.html',
  styleUrls: ['./theme-lab.component.scss'],
  standalone: false,
})
export class ThemeLabComponent {
  constructor(private modalService: NgbModal) {}

  openAbortConfirmModal(): void {
    this.modalService.open(WorldBuilderAbortConfirmModalComponent, { centered: true });
  }

  openLeaveCityConfirm(): void {
    const modalRef = this.modalService.open(ConfirmModalComponent, { centered: true });
    modalRef.componentInstance.title = 'Leave This City?';
    modalRef.componentInstance.message = 'You will move back to the Main Map.';
    modalRef.componentInstance.confirmLabel = 'Yes, Leave';
    modalRef.componentInstance.confirmVariant = 'theme';
    modalRef.componentInstance.confirmClick.subscribe(() => modalRef.close(true));
  }

  openUninviteConfirm(): void {
    const modalRef = this.modalService.open(ConfirmModalComponent, { centered: true });
    modalRef.componentInstance.title = 'Please Confirm';
    modalRef.componentInstance.message = 'Do you want to uninvite the selected players?';
    modalRef.componentInstance.confirmLabel = 'Yes, Uninvite';
    modalRef.componentInstance.confirmClick.subscribe(() => modalRef.close(true));
  }

  openRemoveCharacterModal(): void {
    const modalRef = this.modalService.open(DeleteGameAndCharacterModalComponent, { centered: true });
    modalRef.componentInstance.isAllDisband = false;
  }

  openDisbandPartyModal(): void {
    const modalRef = this.modalService.open(DeleteGameAndCharacterModalComponent, { centered: true });
    modalRef.componentInstance.isAllDisband = true;
  }

  openContentDeleteConfirm(): void {
    this.modalService.open(ContentDeleteModalComponent, { centered: true });
  }

  openDeleteConfirm(): void {
    const modalRef = this.modalService.open(CityEnterDeletemodelComponent, { centered: true });
    modalRef.componentInstance.pagename = 'map';
    modalRef.componentInstance.isNotDelete = false;
  }

  openEnterCityConfirm(): void {
    const modalRef = this.modalService.open(CityEnterDeletemodelComponent, { centered: true });
    modalRef.componentInstance.isNotDelete = true;
  }

  openMapDeleteGate(): void {
    this.modalService.open(MapDeleteComponent, { centered: true, size: 'lg' });
  }

  openMapCleanup(): void {
    const modalRef = this.modalService.open(MapDeleteConfirmationComponent, { centered: true, size: 'lg' });
    // maxMaps and mapNamesToDelete are getters derived from these inputs — don't assign to them directly.
    modalRef.componentInstance.upgradePlan = { name: 'Adventurer', features: { maps_uploaded: 2 } };
    modalRef.componentInstance.mapsToDelete = [
      { map_name: 'Ashmorrow', active_games: 1, active_characters: 3 },
    ];
  }

  openGameCleanup(): void {
    const modalRef = this.modalService.open(GameDeleteConfirmationComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.upgradePlan = { name: 'Adventurer', features: { max_games_created: 1 } };
    modalRef.componentInstance.gameList = [
      { id: 1, Gamename: 'Curse of the Sunken Vault', map_name: 'Ashmorrow', active_characters: [1, 2], LastPlayed: new Date() },
    ];
  }

  openCharacterCleanup(): void {
    const modalRef = this.modalService.open(CharacterDeleteConfirmationComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.upgradePlan = { name: 'Adventurer', features: { max_active_characters: 1 } };
    modalRef.componentInstance.characterList = [
      { id: 1, first_name: 'Sella Wren', primary_class_level: 4, race: 'Elf', primary_class: 'Ranger', map_name: 'Ashmorrow', updated_at: new Date() },
    ];
  }

  openAccountCleanupWizard(): void {
    const modalRef = this.modalService.open(AccountCleanupWizardComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.upgradePlan = { name: 'Adventurer', features: { maps_uploaded: 2, max_games_created: 1, max_active_characters: 1 } };
  }

  openBetaAnnouncement(): void {
    const modalRef = this.modalService.open(ConfirmModalComponent, { centered: true });
    modalRef.componentInstance.title = 'WorldTumbler Beta Is Live';
    modalRef.componentInstance.message = 'We appreciate you joining our early access community. See something odd? Report bugs to support@worldtumbler.com and help us improve!';
    modalRef.componentInstance.confirmLabel = 'Continue';
    modalRef.componentInstance.confirmVariant = 'theme';
    modalRef.componentInstance.showCancel = false;
    modalRef.componentInstance.confirmClick.subscribe(() => modalRef.close('navigate'));
  }

  openSavingLoader(): void {
    this.modalService.open(SavingLoaderModalComponent, { centered: true, backdrop: 'static', keyboard: false });
  }

  openTokenPlacement(): void {
    this.modalService.open(TokenPlacementModalComponent, { centered: true });
  }

  openReportingModal(): void {
    const modalRef = this.modalService.open(ReportingModalComponent, { centered: true });
    modalRef.componentInstance.moduleName = 'Curse of the Sunken Vault';
    modalRef.componentInstance.contentCreator = 'Sella Wren';
  }

  openPlayerStory(): void {
    this.modalService.open(PlayerStoryComponent, { centered: true, size: 'lg' });
  }

  openNoteList(): void {
    const modalRef = this.modalService.open(NoteListComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.noteType = 'game';
    modalRef.componentInstance.notes = [
      { text: 'The party discovered a hidden passage behind the waterfall.', is_private: false },
      { text: 'GM only: the vault key is with the innkeeper, not the mayor.', is_private: true },
    ];
  }

  openCategoryPlayerView(): void {
    this.modalService.open(CategoryPlayerViewModalComponent, { centered: true, size: 'lg' });
  }

  openCreateGameInfo(): void {
    const modalRef = this.modalService.open(CreateGameInfoModalComponent, { centered: true });
    modalRef.componentInstance.map_name = 'Ashmorrow';
  }

  openUploadPartyToken(): void {
    this.modalService.open(UploadpartytokenComponent, { centered: true, size: 'md' });
  }

  openCreateGame(): void {
    this.modalService.open(CreategameComponent, { centered: true });
  }

  openAzgaarInfo(): void {
    this.modalService.open(AzgaarMapGeneratorInfoComponent, { centered: true });
  }

  openMapImageChange(): void {
    this.modalService.open(MapImageChangeComponent, { centered: true });
  }
}
